import apolloProvider from '@/apollo';
import { onLogout } from '@/vue-apollo';
import ErrorHandler from '@/utils/error.handler';


const redirectUrl = process.env.VUE_APP_REDIRECT_URL ?? 'https://app.heycenter.com';

const apollo = apolloProvider.defaultClient;

async function executeQuery(id, query, variables, cache = true, options = {}) {
  try {
    const fetchPolicy = cache ? 'cache-first' : 'no-cache';

    const { data: result } = await apollo.query({
      query,
      variables,
      fetchPolicy,
      ...options,
    });
    return result[id] || [];
  } catch (e) {
    ErrorHandler.logErrors(e);
    if (e.networkError && e.networkError.statusCode === 401) {
      onLogout(apollo);
      window.location.href = redirectUrl;
    }
  }

  return [];
}

export default executeQuery;
